// ----------------------------------------------------------------------
// <copyright file="Izenda.SecurityConfigTenant.js" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var compose = require('recompose').compose;
  var withHandlers = require('recompose').withHandlers;
  const { curry, isNil, isEmpty, split, last } = require('lodash/fp');
  var SecurityConfigTenant = compose(
    withHandlers({
      getTenantFieldOptions: curry(getTenantFieldOptions),
      changeTenantField: curry(changeTenantField),
      addNewTenantField: curry(addNewTenantField),
      blurTenantField: curry(blurTenantField)
    })
  );

  /**
   * Handle change tenant field
   * @param props
   * @param newVal
   */
  function getTenantFieldOptions(props, tenantFieldValue) {
    if (isNil(tenantFieldValue) || isEmpty(tenantFieldValue)) {
      return [];
    }

    return split(';', tenantFieldValue).map(function(item) {
      return {
        label: item,
        value: item
      };
    });
  }

  /**
   * Handle change tenant field
   * @param props
   * @param newVal
   */
  function changeTenantField(props, newVal) {
    var store = props.store;
    var model = store.model;

    if (last(newVal) === ';') {
      newVal = newVal.slice(0, -1);
    }

    model.updateTenantField(newVal);
  }

  /**
   * Handle add new tenant field
   * @param props
   * @param newVal
   */
  function addNewTenantField(props, newData) {
    var store = props.store || {};
    var model = store.model;
    if (!model || isEmpty(newData.value.trim())) {
      return;
    }

    var options = split(';', model.tenantFieldValue);
    // Not in list , add new item
    options.indexOf(newData.value) === -1 && model.addNewTenantField(newData.value);
  }

  /**
   * Handle blur tenant field
   * @param props
   * @param value
   */
  function blurTenantField(props, value) {
    addNewTenantField(props, value);
  }

  module.exports = SecurityConfigTenant;
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/AdvancedSetting/Izenda.SecurityConfigTenantAction.js